import {Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography, useMediaQuery} from "@mui/material";
import {useTheme} from "@mui/material/styles";
import React from "react";
import dayjs from "dayjs";

const MapDialog = ({open, onClose, location}) => {
    const apiToken = 'AIzaSyCgeNF-haEfOwJ_NT7nFLVpAL_YrsEiTEg';
    const theme = useTheme();
    const fullScreen = useMediaQuery(theme.breakpoints.down('xs'));
    const rawCoords = location?.coords
        ? location.coords
        : (location && Number.isFinite(Number(location.latitude)) && Number.isFinite(Number(location.longitude)))
            ? {
                latitude: Number(location.latitude),
                longitude: Number(location.longitude),
                accuracy: location.accuracy,
            }
            : null;
    const timestamp = location?.timestamp || location?.createdAt;

    if (!rawCoords) {
        return (
            <Dialog maxWidth='sm' open={open} onClose={onClose} fullScreen={fullScreen}>
                <DialogTitle>Checkin Location</DialogTitle>
                <DialogContent>
                    <Typography variant="body2" color="text.secondary">
                        Location details are not available for this check-in yet.
                    </Typography>
                </DialogContent>
                <DialogActions>
                    <Button onClick={onClose}>Close</Button>
                </DialogActions>
            </Dialog>
        );
    }

    return (
        <Dialog maxWidth='lg' open={open} onClose={onClose} fullScreen={fullScreen}>
            <DialogTitle>Checkin Location</DialogTitle>
            <DialogContent>
                <Typography variant="h5">Accuracy: {rawCoords.accuracy ?? 'N/A'}</Typography>
                <Typography variant="h6">Date: {timestamp ? dayjs(timestamp).format('MM/DD/YYYY HH:mm:ss a') : 'N/A'}</Typography>
                <iframe
                    width="800"
                    height="600"
                    title="Checkin location map"
                    frameBorder="0"
                    style={{border: 0}}
                    referrerPolicy="no-referrer-when-downgrade"
                    src={`https://www.google.com/maps/embed/v1/search?key=${apiToken}&q=${rawCoords.latitude},${rawCoords.longitude}&zoom=18`}
                    allowFullScreen>
                </iframe>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose}>Close</Button>
            </DialogActions>
        </Dialog>
    );
}

export default MapDialog;
